import React, { createContext, useContext, useState } from "react";
import { Outlet } from "react-router-dom";

const RoFormContext = createContext();

export const RoFormProvider = ({ children }) => {
    const [formData, setFormData] = useState({});
    const [completedSteps, setCompletedSteps] = useState([]);

    const updateFormData = (newData, step) => {
        setFormData(prev => ({ ...prev, ...newData }));
        if (step && !completedSteps.includes(step)) {
            setCompletedSteps(prev => [...prev, step]);
        }
    };

    return (
        <RoFormContext.Provider value={{ formData, updateFormData, completedSteps, setCompletedSteps }}>
            {children}
        </RoFormContext.Provider>
    );
};

export const useRoForm = () => {
    const context = useContext(RoFormContext);
    if (!context) throw new Error("useRoForm must be used within Provider");
    return context;
};




export default function RoFormLayout() {
    return (
        <RoFormProvider>
            <Outlet />
        </RoFormProvider>
    );
}

